import { useEffect } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { Panel, PanelHead, PanelTitle } from '@widgets/GeoSchemes';
import { StepShell, useWizard } from './wizard';
import { DesignPanel } from './DesignPanel';
import { SurveyPanel } from './SurveyPanel';
import { MiniPlan } from './MiniPlan';

const Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.spacing(4)};
  align-items: start;

  @container geo-wizard (min-width: 1180px) {
    grid-template-columns: 1fr 1fr;
  }
`;

/** Шаг 6. Съёмка и проектные данные + мини-план «всё ли легло куда надо». */
export function StepData() {
  const { scheme } = useWizard();
  const { hash } = useLocation();

  // Быстрая ссылка «Править точки съёмки» с шага 9 ведёт сюда с #geo-survey.
  useEffect(() => {
    if (hash !== '#geo-survey') return;
    const el = document.getElementById('geo-survey');
    if (el) {
      el.scrollIntoView({ block: 'start' });
      el.focus({ preventScroll: true });
    }
  }, [hash]);

  return (
    <StepShell
      n={6}
      lead="Проектные элементы — что должно быть по РД; съёмка — что получилось на площадке. Обе стороны — в МСК: X на север, Y на восток. Ручные правки съёмки сохраняются только с причиной и попадают в журнал."
    >
      <Columns>
        <DesignPanel />
        <SurveyPanel />
      </Columns>
      <Panel>
        <PanelHead>
          <PanelTitle>Мини-план</PanelTitle>
        </PanelHead>
        <MiniPlan scheme={scheme} />
      </Panel>
    </StepShell>
  );
}
